import React, { createRef } from "react";
import Styles from "./NSBoxFile.module.css"
import { InboxOutlined } from '@ant-design/icons';
import { Upload } from "antd";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { IValidationProps } from "../props/IValidationProps";
import { RcFile, UploadChangeParam, UploadFile } from "antd/es/upload";
import { safeMenuMenuItem } from "./NSMenuButton";
import { INSBoxBaseLayoutProps, NSBoxBaseLayout } from "./NSBoxBaseLayout";

export interface NSBoxFileProps extends IBaseComponentProps, IValidationProps, INSBoxBaseLayoutProps<NSBoxFile, string>
{
	showUploadList?: boolean;
	maxFilesCount?: number;
	multiple?: boolean;
	hideHeader?: boolean;
	onSelected?: (info: UploadChangeParam<UploadFile>) => void;
	onDroped?: (e: React.DragEvent<HTMLDivElement>) => void;
	onUpload?: (file: RcFile, fileList: RcFile[], getContent: (file: RcFile, onSuccess: (content: string | ArrayBuffer) => void) => void) => Promise<void>;
}

export interface NSBoxFileState
{
	file: File | null;
}

export class NSBoxFile extends React.Component<NSBoxFileProps, NSBoxFileState> 
{
	NSBoxBaseLayout_Main = createRef<NSBoxBaseLayout>();
	constructor(props: NSBoxFileProps)
	{
		super(props);
		this.state = {
			file: null,
		};
	}

	override render()
	{
		let menu = safeMenuMenuItem(this.props, () => { });

		return (
			<NSBoxBaseLayout
				ref={this.NSBoxBaseLayout_Main}
				{...this.props}
				menu={menu}
			>
				<div className={`${Styles.ns_box_file_dagger_parent}`} >
					<Upload.Dragger
						id={this.props.id}
						name={this.props.name}
						style={{ border: "none" }}
						maxCount={this.props.maxFilesCount}
						multiple={this.props.multiple}
						onChange={(info) =>
						{
							if (this.props.onChanged)
								this.props.onChanged(this);
							if (this.props.onSelected)
								this.props.onSelected(info)
						}}
						onDrop={this.props.onDroped}
						beforeUpload={async (f, l) =>
						{
							if (this.props.onUpload)
								await this.props.onUpload(f, l, async (file, onSuccess) =>
								{
									const reader = new FileReader();
									reader.onload = (e) =>
									{
										if (e?.target)
										{
											const content = e.target.result;
											if (content)
												try
												{
													onSuccess(content);
												} catch (error)
												{
												}
										}
									};
									reader.readAsText(file);
								});
							return false;
						}}
						showUploadList={this.props.showUploadList}
					>
						<p className="ant-upload-drag-icon">
							<InboxOutlined style={{ color: "#141B5C" }} />
						</p>
						<p className="ant-upload-text" style={{ color: "#141B5C" }}>Click or drag file to this area to upload</p>
						<p className="ant-upload-hint" style={{ color: "#141B5C" }}>
							Support for a single or bulk upload. Strictly prohibited from uploading company data or other
							banned files.
						</p>
					</Upload.Dragger>
				</div>
			</NSBoxBaseLayout>
		)
	}
}